import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ContractorTransferPreview, ContractorTransferRequest } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  payload: ContractorTransferRequest
  /** Only what moves, with the plan's errors and warnings: no row counts per table and no readings estimate (`readings` is null) */
  planOnly?: boolean
  options?: Omit<UseQueryOptions<ContractorTransferPreview, Error>, 'queryKey' | 'queryFn'>
}

/** The impact report of a transfer. It writes nothing, so it is a query keyed by the request it previews. */
export const useContractorTransferPreviewRequest = ({ payload, planOnly = false, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<ContractorTransferPreview, Error>(
    [Entities.ContractorTransfers, 'preview', JSON.stringify(payload), planOnly],
    async () => {
      const { data } = await api.v1AdminContractorTransfersPreviewPost(payload, planOnly || undefined)
      return data as unknown as ContractorTransferPreview
    },
    { ...options }
  )
}
